import axio from '../js/axio'

//export const HTTPS = 'http://localhost:5000' // 本机
//export const HTTPS = 'https://localhost:5001' // 本机
//export const HTTPS = 'http://114.116.96.37:6604' // 本地测试
export const HTTPS = 'https://alljapan.jhss-jp.com' // 本地正式
//export const HTTPS = 'http://8.209.222.249:8088' // 测试发布
//export const HTTPS = '' // 生产发布

// 用户登录
export const login = data => axio('/api/SysUser/Login', data)

// 获取用户顶级菜单权限
export const getPermission = data => axio('/api/SysUser/GetMenuByUser', data)

// 获取用户子菜单权限
export const getDtPermission = data => axio('/api/SysUser/GetMenuDtByUser', data)

// 获取客户列表
export const getCustomer = data => axio('/api/SysUser/GetAllDataUser2', data)

// 添加客户
export const setCustomer = data => axio('/api/SysUser/SetDataUser', data)

// 删除客户
export const delCustomer = data => axio('/api/SysUser/DelDataUser', data)

// 获取客户地址
export const getCustomerAddressee = data => axio('/api/WlAddress/GetAddress', data)

// 添加、修改客户寄件地址
export const setCustomerAddressee = data => axio('/api/WlAddress/SetAddress', data)

// 删除客户地址
export const delCustomerAddressee = data => axio('/api/WlAddress/DelAddress', data)

// 订单管理/订单查看-查询订单地址
export const getProvince = data => axio('/api/WlOrder/GetAddressDetailLst', data)

// 查询订单
export const getOrderList = data => axio('/api/WlOrder/GetOrder', data)

// 导出订单
export const exportOrders = data => axio('/api/Xlsx/ExportOrder', data)
// 导出订单--小包
export const exportOrdersXiaoBao = data => axio('/api/Xlsx/ExportOrderXiaoBao', data)

// 条形码地址
export const imgSrc = data => { return HTTPS + '/uploadfiles/' + data }

// 物流图片地址
export const imgSrc2 = data => { return HTTPS + '/uploadfiles2/' + data }

// 不是管理员登录时，查询登录用户寄件人信息和收件人列表
export const getUserData = data => axio('/api/SysUser/GetDataUserByUserID', data)

// 添加、修改订单
export const setOrder = data => axio('/api/WlOrder/SetOrder', data)

// 作废订单
export const setOrderState = data => axio('/api/WlOrder/SetOrderState', data)

//查询垃圾箱订单
export const getOrderRecycleBin = data => axio('/api/WlJzx/GetDelAll', data)

// 删除订单
export const delOrder = data => axio('/api/WlOrder/DelOrder', data)

// 查询订单物流信息
export const getLogistics = data => axio('/api/WlOrder/GetOrderDt', data)

// 物流订单开始配送 0 => 1
export const startDistribution = data => axio('/api/WlOrder/OrderStart', data)

// 上传物流流程图片
export const uploadPhoto = HTTPS + '/api/UpLoadFile/FileSave2'

// 物流订单完成配送 1 => 2
export const endLogistics = data => axio('/api/WlOrder/OrderEnd', data)

// 新建、修改订单物流信息
export const setLogistics = data => axio('/api/WlOrder/SetOrderDt', data)

// 删除订单物流信息
export const delLogistics = data => axio('/api/WlOrder/DelOrderDt', data)

// 确认订单物流信息已完成，订单已签收
export const endOrder = data => axio('/api/WlOrder/EndOrder', data)

// 查询签收单信息
export const getSignatureList = data => axio('/api/WlQsd/GetQsd', data)

// 新增签收单信息
export const setSignatureForm = data => axio('/api/WlQsd/SetQsd', data)

// 删除签收单信息
export const delSignatureForm = data => axio('/api/WlQsd/DelQsd', data)

// 查询可用订单信息
export const getAvailableOrder = data => axio('/api/WlQsd/GetCanUseOrder', data)

// 查询签收单子订单信息
export const getSignOrders = data => axio('/api/WlQsd/GetQsdOrder', data)

// 插入订单信息
export const setSignOrders = data => axio('/api/WlQsd/SetQsdOrdernum', data)

// 查询签收单图片信息
export const getSignImgs = data => axio('/api/WlQsd/GetQsdPic', data)

// 上传图片、上传excel
export const uploadImg = () => { return HTTPS + '/api/UpLoadFile/FileSave' }

// 读取excel
export const readExcel = data => axio('/api/UpLoadFile/ReadExcel', data)

// 确定导入excel
export const confirmImportExcel = data => axio('/api/WlOrder/SetOrderByExcel', data)

// 插入签收单图片
export const setSignImgs = data => axio('/api/WlQsd/SetQsdPic', data)

// 完成签收单
export const endSignatureForm = data => axio('/api/WlQsd/EndQsd', data)

// 物流详情
export const getLogisticsDetails = data => axio('/api/WlOrder/GetOrderDt', data)

// 查询日本配送区域 
export const getDeliveryArea = data => axio('/api/SysUser/GetJpQy', data)

// 查询配送员列表
export const getDeliveryMenList = data => axio('/api/SysUser/GetAllPostMan', data)

// 添加、修改配送员
export const setDeliveryMan = data => axio('/api/SysUser/SetPostMan', data)
//添加配送员/正式员工打卡信息
export const setDeliveryClock = data => axio('/api/WlWork/AdminPcSign',data)
//添加勤务日外
export const setWorkQwrw = data => axio('/api/WlWork/SetWorkQwrw',data)
//删除勤务日外
export const delWorkSign = data => axio('/api/WlWork/DelWorkSign',data)
//添加临时工打卡信息
export const setLsgClock = data => axio('/api/WlWork/AdminPcSignLsg',data)


// 删除配送员
export const delDeliveryMan = data => axio('/api/SysUser/DelPostMan', data)

// 获取配送员列表
export const getDeliveryMan = data => axio('/api/WlQuery/QueryPostManName', data)

// 查询配送明细
export const getDeliveryDetailOrder = data => axio('/api/WlQuery/GetOrder', data)

// 导出配送明细
export const exportExcel = data => axio('/api/Xlsx/Export2', data)

// 查询配送统计
export const getDeliveryMen = data => axio('/api/WlQuery/GetPostQuery', data)

// 查询临时员工列表
export const getTempeoraryList = data => axio('/api/SysUser/GetAllSignMan', data)

// 新增、修改临时员工
export const setTempeoraryMan = data => axio('/api/SysUser/SetSignMan', data)

// 删除临时员工
export const delTempeoraryMan = data => axio('/api/SysUser/DelSignMan', data)

// 查询今日临时工打卡人数
export const getTodayTemporary = data => axio('/api/WlSign/GetTodaySign', data)

// 查询临时员工打卡记录
export const getTemporaryClock = data => axio('/api/WlSign/GetSignDtByUser', data)
export const delTemporaryClock = data => axio('/api/WlSign/DelSignSign', data)

// 管理员为临时员工上班修改
export const setTemporaryPunchIn = data => axio('/api/WlSign/PcSign1Time', data)

// 管理员为临时员工补卡
export const setTemporaryPunchOut = data => axio('/api/WlSign/PcSign', data)

// 导出临时员工工资表（多人）
export const exportMoreTempeorary = data => axio('/api/xlsx/ExportAllWlSign', data)

// 导出临时员工工资表（单人）
export const exportSingleTempeorary = data => axio('/api/xlsx/ExportWlSign', data)

// 未录入集装箱信息
export const noEnterContain = data => axio('/api/WlJzx/GetNotJzxOrder', data)

// 集装箱信息
export const getContainerInfo = data => axio('/api/WlJzx/GetDtByCityAndDate', data)

// 查询指定日期集装箱订单信息
export const getContainerOrder = data => axio('/api/WlJzx/GetAll', data)

// 新建、修改集装箱订单信息
export const setContainerOrder = data => axio('/api/WlJzx/SetInfo', data)

// 查看附件
export const checkAttachment = data => axio('/api/WlJzx/GetAllFile', data)

// 删除集装箱订单
export const delContainerOrder = data => axio('/api/WlJzx/DelMain', data)
// 更新集装箱订单打印状态
export const setprintContainerOrder = data => axio('/api/WlJzx/UpQsd', data)

// 更新集装箱状态
export const updateContainerStatus = data => axio('/api/WlJzx/UpDateMain', data)
// 更新集装箱状态
export const updateXuKe = data => axio('/api/WlJzx/UpXuKeMain', data)

// 导出集装箱订单
export const exportContainerOrder = data => axio('/api/Xlsx/ExportJzx', data)

// 查询当天集装箱关西签收单
export const getOneDayKansaiReceipt = data => axio('/api/WlJzx/GetAllQSD2', data)

// 查询当天集装箱关东签收单
export const getOneDayKantoReceipt = data => axio('/api/WlJzx/GetAllGdQSD2', data)

// 查询当天集装箱关东签收单
export const getOneDayReturnReceipt = data => axio('/api/WlJzx/GetAllHCD2', data)

// 集装箱签收单，下载单个文件
export const loadOneFile = data => axio('/api/WlJzx/SetDownLog', data)

// 集装箱签收单，下载多个文件
export const loadMultipleFiles = data => axio('/api/WlJzx/SetDownZipLog', data)

// 查询上传集装箱关西签收单
export const getKansaiReceipt = data => axio('/api/WlJzx/GetAllQSD', data)

// 绑定上传集装箱关西签收单
export const setKansaiReceipt = data => axio('/api/WlJzx/SetQsd', data)

// 删除上传集装箱关西签收单
export const delKansaiReceipt = data => axio('/api/WlJzx/DelQsd', data)

// 查询上传集装箱关东签收单
export const getKantoReceipt = data => axio('/api/WlJzx/GetAllGdQSD', data)

// 绑定上传集装箱关东签收单
export const setKantoReceipt = data => axio('/api/WlJzx/SetGdQsd', data)

// 删除上传集装箱关东签收单
export const delKantoReceipt = data => axio('/api/WlJzx/DelGdQsd', data)

// 查询上传集装箱回传签收单
export const getReturnReceipt = data => axio('/api/WlJzx/GetAllHCD', data)

// 绑定上传集装箱回传签收单
export const setReturnReceipt = data => axio('/api/WlJzx/SetHcd', data)

// 删除上传集装箱回传签收单
export const delReturnReceipt = data => axio('/api/WlJzx/DelHcd', data)

// 查询上传集装箱账单
export const getBillFiles = data => axio('/api/WlJzx/GetAllZdFile', data)

// 绑定上传集装箱账单
export const setBillFiles = data => axio('/api/WlJzx/SetZdFile', data)

// 删除上传集装箱账单
export const delBillFiles = data => axio('/api/WlJzx/DelZdFile', data)

// 查询上传集装箱异常情况附件
export const getAbnormalAttachment = data => axio('/api/WlJzx/GetAllYC', data)

// 绑定上传集装箱异常情况附件
export const setAbnormalAttachment = data => axio('/api/WlJzx/SetYc', data)

// 删除上传集装箱异常情况附件
export const delAbnormalAttachment = data => axio('/api/WlJzx/DelYc', data)

// 集装箱信息发送邮件
export const sendContainerEmail = data => axio('/api/WlJzx/PostJzxMail', data)

// 查询集装箱订单信息
export const queryContainerOrder = data => axio('/api/WlJzx/GetAll', data)

// 根据集装箱编号查物流询订单信息
export const containerGetOrder = data => axio('/api/WlJzx/GetOrderByJzxnum', data)

// 选中订单设置集装箱信息
export const setOrdersContainer = data => axio('/api/WlOrder/UpMoJzxByOrder', data)

// 查询正式员工列表
export const getformalList = data => axio('/api/SysUser/GetAllWorkMan', data)

// 新增、修改正式员工
export const setformalMan = data => axio('/api/SysUser/SetWorkMan', data)

// 删除正式员工
export const delformalMan = data => axio('/api/SysUser/DelWorkMan', data)

// 查询正式员工打卡记录
export const getformalClock = data => axio('/api/WlWork/GetWorkDtByUser', data)

// 导出正式员工打卡记录（多人）
export const exportMoreFormal = data => axio('/api/xlsx/ExportAllWlWork', data)

// 导出正式员工打卡记录（单人）
export const exportSingleFormal = data => axio('/api/Xlsx/ExportWlWork', data)

// 查询今日正式工打卡人数
export const getTodayFormal = data => axio('/api/WlWork/GetTodaySign', data)

// 管理员为打卡人员上班修改
export const setFormalPunchIn = data => axio('/api/WlWork/PcSign1Time', data)

// 管理员为打卡人员下班补卡
export const setFormalPunchOut = data => axio('/api/WlWork/PcSign', data)

// 查询商品在库表
export const getReservedCargo = data => axio('/api/WlKu/GetAll', data)

// 新建或修改商品在库表
export const setReservedCargo = data => axio('/api/WlKu/SetKu', data)

// 删除商品在库表
export const delReservedCargo = data => axio('/api/WlKu/DelKu', data)

// 上传完绑定
export const reservedBingFile = data => axio('/api/WlKu/SetFile', data)

// 获取亚马逊签收单日历
export const getAmazonSignIn = data => axio('/api/WlAmazon/GetQsdLst', data)

// 客户查看签收单图片
export const getSignInImgChekc = data => axio('/api/WlAmazon/GetQsd', data)

// 客户创建签收单图片
export const setSignInImg = data => axio('/api/WlAmazon/SetQsd', data)

// 获取亚马逊订单信息
export const getAmazonOrder = data => axio('/api/WlAmazon/GetAmazon', data)

// 上传亚马逊订单信息
export const setAmazonOrder = data => axio('/api/WlAmazon/SetAmazon', data)

// 批量设置物流信息
export const batchSetLogistics = data => axio('/api/WlAmazon/SetWl', data)

// 批量设置状态
export const batchSetStatus = data => axio('/api/WlAmazon/SetState', data)

// 查询状态说明
export const checkOrderStatus = data => axio('/api/WlAmazon/GetStateByPid', data)

// 查询物流信息
export const checkOrderLogistics = data => axio('/api/WlAmazon/GetWlByPid', data)

// 删除物流信息
export const delOrderLogistics = data => axio('/api/WlAmazon/DelWl', data)

// 批量删除
export const batchDelOrders = data => axio('/api/WlAmazon/DelAmazon', data)

// 批量删除
export const batchDelOrdersYs = data => axio('/api/WlAmazon/DelAmazonYs', data)

// 集装箱订单明细导出
export const exportContainerDetail = data => axio('/api/xlsx/ExportAmazon', data)

// 订单查询页面单独接口
export const queryOrder = data => axio('/api/WlAmazon/GetAmazon2', data)

// 集装箱订单---标签上传、删除、一条订单的标签文件查询
export const getTallyFile = data => axio('/api/WlJzx/GetAllBiaoQian', data)

// 上传
export const setTallyFile = data => axio('/api/WlJzx/SetBiaoQian', data)

// 删除
export const delTallyFile = data => axio('/api/WlJzx/DelBiaoQian', data)

// 标签备注
export const setTallyFileRemark = data => axio('/api/WlJzx/SetBiaoQianRemark', data)

export const getQrCode = data => axio('/api/WlJzx/GetQrCode', data)


// 上传SKU文件
export const setSKUTallyFile = data => axio('/api/WlJzx/SetBiaoQianDt', data)

// 删除SKU文件
export const delSKUTallyFile = data => axio('/api/WlJzx/DelBiaoQianDt', data)


//上传 删除FBA标签文件
export const BinBiaoQianFile = data => axio('/api/WlJzx/BinBiaoQianFile', data)
//上传 删除SKU标签文件
export const BinBiaoQianDtFile = data => axio('/api/WlJzx/BinBiaoQianDtFile', data)

export const BianQianQrPage = data => {return HTTPS+'/pdf/BianQianQrPage?JZXID='+data}

// 获取SKU文件
export const getSKUTallyFile = data => axio('/api/WlJzx/GetBiaoQianDt', data)

//作废集装箱标签
export const DelBiaoQianLst = data => axio('/api/WlJzx/DelBiaoQianLst', data)

//导入集装箱标签
export const SetBiaoQianLst = data => axio('/api/WlJzx/SetBiaoQianLst', data)

//文件导出
export const ExportWlBiaoQian = data => axio('/api/Xlsx/ExportWlBiaoQian', data)

//下载文件导出
export const DownloadFile = data => {return HTTPS+'/xlsx/'+data}

// 集装箱订单---当天的标签文件查询
export const getDayTallyFile = data => axio('/api/WlJzx/GetAllBiaoQian2', data)

// 确认标签文件
export const affirmTallyFile = data => axio('/api/WlJzx/TakeBiaoQian', data)

// 修改集装箱订单担当者
export const editHeader = data => axio('/api/WlJzx/SetDdr', data)

// 获取调度管理日历信息
export const getDiaoDuInfo = data => axio('/api/DiaoDu/GetDtByCityAndDate', data)
//添加、修改送货行程
export const editSongHuo = data => axio('/api/DiaoDu/SetSongHuo', data)
//添加、修改送货行程
export const getSongHuoOrder = data => axio('/api/DiaoDu/GetSongHuo', data)
//删除送货订单
export const delSongHuoOrder = data => axio('/api/DiaoDu/DelSongHuo', data)

//获取调度主表信息
export const GetDiaoDuMain = data => axio('/api/DiaoDu/GetDiaoDuMain', data)

//添加临时车辆信息
export const SetLinShiCarNo = data => axio('/api/DiaoDu/SetLinShiCarNo', data)
//绑定司机
export const BindDriver = data => axio('/api/DiaoDu/BindDriver', data)
//添加车辆调度详情
export const SetDiaoDuDetails = data => axio('/api/DiaoDu/SetDiaoDuDetails', data)
//解除绑定
export const DelDiaoDuDetails = data => axio('/api/DiaoDu/DelDiaoDuDetails', data)
//更新集装箱订单司机，车牌
export const UpDataCarAndDriver = data => axio('/api/WlJzx/UpDataCarAndDriver', data)


//小包业务
export const XiaoBaoGetAll = data => axio('/api/KuaiDi/GetAll', data)
export const SetXiaoBaoImport = data => axio('/api/KuaiDi/SetImport', data)
export const SetXiaoBaoUpdateImport = data => axio('/api/KuaiDi/SetUpdateImport', data)
export const SetBaoGuo = data => axio('/api/KuaiDi/SetBaoGuo', data)

// 查询临时员工列表
export const getKdList = data => axio('/api/SysUser/GetAllKdMan', data)
// 新增、修改临时员工
export const setKdMan = data => axio('/api/SysUser/SetKdMan', data)
// 删除临时员工
export const delKdMan = data => axio('/api/SysUser/DelKdMan', data)
//查询快递物流轨迹
export const GetKdGuiJi = data => axio('/api/KuaiDi/GetKdGuiJi', data)

//---------------包裹管理----------------------------
// 查询包裹列表
export const getKdBaoGuoList = data => axio('/api/KuaiDi/GetBaoGuo', data)
// 新增、修改包裹
export const setKdBaoGuo = data => axio('/api/KuaiDi/SetBaoGuo', data)
// 删除包裹
export const delKdBaoGuo = data => axio('/api/KuaiDi/DelBaoGuo', data)


//---------------区域管理----------------------------
// 查询区域列表
export const KdBaoGuoAreaGetAll = data => axio('/api/KdBaoGuoArea/GetAll', data)

//BL相关-----------------------------------------
export const getBLList = data => axio('/api/BL/GetAll', data)
// 新增、修改
export const setBL = data => axio('/api/BL/SetInfo', data)
// 删除
export const delBL = data => axio('/api/BL/Del', data)
export const GetOneBL = data => axio('/api/BL/GetOne', data)


export const getBLChildList = data => axio('/api/BLCHILD/GetAll', data)
export const SetBLCHILDImport = data => axio('/api/BLCHILD/SetImport', data)
export const delBLChild = data => axio('/api/BLCHILD/DelMul', data)
export const PrintBan = data => axio('/api/Print/PrintBan', data)
export const PrintBL = data => axio('/api/Print/PrintBL', data)
export const UpdateInfo = data => axio('/api/BLCHILD/UpdateInfo', data)